module.exports = __webpack_public_path__ + "assets/img/title-8170ec44.png";